import React from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import { PageInfo } from '../../components/PageInfo/PageInfo'
import { Page } from '../../components/Page/Page'
import { SectionBlock } from '../../components/SectionBlock/SectionBlock'

import { DataProtection } from '../../components/DataProtection/DataProtection'

const DataProtectionPage = ({ t }) => {
    return (
        <Page title={t('dataProtectionTitle')} description={t('contactPageDescription')}>
            <PageInfo
                breadcrumbs={t('dataProtection.breadcrumbs')}
                title={t('dataProtectionTitle')}
                bgImage="/images/data-protection.jpg"
                overlay
            />
            <SectionBlock withContainer>
                <DataProtection text={t('dataProtectionText')} />
            </SectionBlock>
        </Page>
    )
}

DataProtectionPage.propTypes = {
    t: PropTypes.func
}

export default withTranslation()(DataProtectionPage)
